import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import { State } from '../../types/state';

const initialState: State[] = [];

export const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setCountryStates: (_, action: PayloadAction<State[]>) => {
      return action.payload;
    },
    clearCountryStates: () => initialState,
  },
});

export const {
  setCountryStates,
  clearCountryStates 
} = countrySlice.actions;

export default countrySlice.reducer;

const getCountryStates = (state: RootState) => state.country;

export const selectCountryStatesDropdownOptions = createSelector(
  [getCountryStates],
  (countryStates) => 
    countryStates.map(stateObj => ({
      value: stateObj.isoCode,
      label: stateObj.name
    }))
);